import { render, staticRenderFns } from "./casePhoneList.vue?vue&type=template&id=4fc46994&scoped=true"
import script from "./casePhoneList.vue?vue&type=script&lang=js"
export * from "./casePhoneList.vue?vue&type=script&lang=js"
import style0 from "./casePhoneList.vue?vue&type=style&index=0&id=4fc46994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc46994",
  null
  
)

export default component.exports